import React, { memo } from 'react';
import { useFormContext } from 'react-hook-form';
import classNames from 'classnames';
import _get from 'lodash/get';
import _replace from 'lodash/replace';
import IconButton, {
  IconButtonTypes,
} from '@lib/components/IconButton/IconButton';
import styles from './OptionsFieldOption.module.scss';

interface Props {
  onRemove: () => void;
  parentIndex?: number;
  parentName: string;
  subFieldsMinLength?: number;
  children: React.ReactNode;
}

function OptionsFieldOption(props: Props) {
  const { onRemove, parentIndex, parentName, subFieldsMinLength, children } =
    props;
  const { getValues } = useFormContext();
  const values = getValues();
  const fieldValue = _get(values, _replace(parentName, '.options', ''));
  const isDeleteBtnVisible = subFieldsMinLength
    ? fieldValue?.length > subFieldsMinLength
    : true;

  return (
    <div
      className={classNames(styles.optionWrap, {
        [styles.optionWrapWithDelete]: isDeleteBtnVisible,
      })}
      data-test-id={`field-array__option-${parentName}${parentIndex !== undefined ? `-${parentIndex}` : ''}`}
    >
      {children}
      {isDeleteBtnVisible && (
        <IconButton
          icon="close"
          rounded
          type={IconButtonTypes.TertiaryFilled}
          onClick={onRemove}
          className={styles.optionDeleteBtn}
          data-test-id={`field-array__option-delete-${parentName}${parentIndex !== undefined ? `-${parentIndex}` : ''}`}
        />
      )}
    </div>
  );
}

export default memo(OptionsFieldOption);
